import { useTranslation } from "react-multi-lang";


interface iProps {cell:{value?:string}}

export const ImageLinkCell = ( {cell} :iProps) => {
    const t = useTranslation()

    const handleClick = (e:React.MouseEvent) => {

    e.stopPropagation(); 
    // if (cell.value) {
    //   window.open(cell.value, '_blank', 'noopener,noreferrer');
    // }
  };
  if (!cell.value) return null;

  return (
    <a
      onClick={handleClick}
      href={cell.value}
  
      rel="noopener noreferrer"
      style={{ color: "#1a73e8"
        , textDecoration: "underline" ,
    zIndex: 9999,
position: 'relative',
pointerEvents: 'auto'}}
    >
     {t('invoice_copy')}
    </a>
  );
};